import Component from '@glimmer/component'
import { tracked } from '@glimmer/tracking'
import { action } from '@ember/object'

interface Args {
  onReveal: (event: RevealerEvent) => void
  onConceal: (event: RevealerEvent) => void
}

export type RevealerEvent =
  | (MouseEvent & { revealerActioned?: boolean })
  | (FocusEvent & { revealerActioned?: boolean })

interface Signature {
  Args: Args
  Blocks: {
    concealed: [Args['onReveal']]
    revealed: [Args['onConceal']]
  }
}

export class Revealer extends Component<Signature> {
  @tracked isConcealed = true

  @action
  revealAction(event: RevealerEvent) {
    if (this.isConcealed && !event.revealerActioned) {
      event.revealerActioned = true // mark the event to avoid it ever causing both reveal & conceal for the same event
      this.isConcealed = false
      this.args.onReveal?.(event)
    }
  }

  @action
  concealAction(event: RevealerEvent) {
    if (!this.isConcealed && !event.revealerActioned) {
      event.revealerActioned = true
      this.isConcealed = true
      this.args.onConceal?.(event)
    }
  }

  <template>
    {{#if this.isConcealed}}
      {{#if (has-block "concealed")}}
        {{yield this.revealAction to="concealed"}}
      {{/if}}
    {{else}}
      {{#if (has-block "revealed")}}
        {{yield this.concealAction to="revealed"}}
      {{/if}}
    {{/if}}
  </template>
}

export default Revealer
